<template>
    <div>
        <div v-if="show_loader" class="spinner-border text-success" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div v-else>
            <slot :data="data"></slot>
        </div>
    </div>
</template>

<script>


export default {
    name: "container.vue",
    mixins: [
        window.ModularForms.MixinsVue.ajax
    ],
    props: {
        element: {
            type: String,
            default: ''
        }
    },

    data: function () {
        return {
            data: {}
        }
    },
    async mounted() {

    },
    methods: {

        success: function (response) {
            if (response.status === false) {
                this.timeout = true;
                return;
            }
            if (typeof response === 'object') {
                this.data = response.records;

            } else {
                this.error_returned = true;
            }
        }
    }
}
</script>
